module.exports = __webpack_public_path__ + "static/img/video_guan.d8fba4d6.png";